/**
 * Phonics Letter Ff — 课程数据配置
 *
 * 媒体资源基础路径（对应服务器 /media/phonics/ff/）
 */

const MEDIA_BASE = '/media/phonics/ff';
const V = 'v1';

export const letterData = {
  letter: 'F',
  title: 'Phonics',
  subtitle: 'Letter F',

  mediaBase: MEDIA_BASE,

  // Step 1: 歌曲视频片段
  songVideo: {
    src: `${MEDIA_BASE}/Ff.mp4?${V}`,
    startTime: 8,
    endTime: 76,
  },

  // Step 2: 4格单词视频
  wordVideos: [
    { id: 1, src: `${MEDIA_BASE}/video_s3_word1.mp4?${V}`, cover: `${MEDIA_BASE}/image9.png?${V}` },
    { id: 2, src: `${MEDIA_BASE}/video_s3_word2.mp4?${V}`, cover: `${MEDIA_BASE}/image10.png?${V}` },
    { id: 3, src: `${MEDIA_BASE}/video_s3_word3.mp4?${V}`, cover: `${MEDIA_BASE}/image11.png?${V}` },
    { id: 4, src: `${MEDIA_BASE}/video_s3_word4.mp4?${V}`, cover: `${MEDIA_BASE}/image12.png?${V}` },
  ],

  // Step 3-5: Vocab 三组（video-left-vocab-right）
  // Step 6-7: Story（video-top-lines-bottom）
  // Step 8: Chant
  storySections: [
    // Step 3: Learn the words (1) — hungry / finds / big
    {
      label: 'Learn the words (1)',
      layout: 'video-left-vocab-right',
      videos: [{ src: `${MEDIA_BASE}/video_words1_hungry.mp4?${V}`, poster: `${MEDIA_BASE}/image13.png?${V}` }],
      splitAt: 3,
      lines: [
        { en: 'hungry', cn: '饥饿的', audioEn: `${MEDIA_BASE}/w_en_hungry.mp3?${V}`, audioCn: `${MEDIA_BASE}/w_cn_hungry.mp3?${V}` },
        { en: 'finds', cn: '找到', audioEn: `${MEDIA_BASE}/w_en_finds.mp3?${V}`, audioCn: `${MEDIA_BASE}/w_cn_finds.mp3?${V}` },
        { en: 'big', cn: '大', audioEn: `${MEDIA_BASE}/w_en_big.mp3?${V}`, audioCn: `${MEDIA_BASE}/w_cn_big.mp3?${V}` },
      ],
    },

    // Step 4: Learn the words (2) — flip / flop / full
    {
      label: 'Learn the words (2)',
      layout: 'video-left-vocab-right',
      videos: [{ src: `${MEDIA_BASE}/video_words2_flip.mp4?${V}`, poster: `${MEDIA_BASE}/image14.png?${V}` }],
      splitAt: 3,
      lines: [
        { en: 'flip', cn: '翻动', audioEn: `${MEDIA_BASE}/w_en_flip.mp3?${V}`, audioCn: `${MEDIA_BASE}/w_cn_flip.mp3?${V}` },
        { en: 'flop', cn: '扑腾', audioEn: `${MEDIA_BASE}/w_en_flop.mp3?${V}`, audioCn: `${MEDIA_BASE}/w_cn_flop.mp3?${V}` },
        { en: 'full', cn: '满了、饱了', audioEn: `${MEDIA_BASE}/w_en_full.mp3?${V}`, audioCn: `${MEDIA_BASE}/w_cn_full.mp3?${V}` },
      ],
    },

    // Step 5: Learn the words (3) — hot / flap / cool
    {
      label: 'Learn the words (3)',
      layout: 'video-left-vocab-right',
      videos: [{ src: `${MEDIA_BASE}/video_words3_hot.mp4?${V}`, poster: `${MEDIA_BASE}/image15.png?${V}` }],
      splitAt: 3,
      lines: [
        { en: 'hot', cn: '热的', audioEn: `${MEDIA_BASE}/w_en_hot.mp3?${V}`, audioCn: `${MEDIA_BASE}/w_cn_hot.mp3?${V}` },
        { en: 'flap', cn: '扇动', audioEn: `${MEDIA_BASE}/w_en_flap.mp3?${V}`, audioCn: `${MEDIA_BASE}/w_cn_flap.mp3?${V}` },
        { en: 'cool', cn: '凉快', audioEn: `${MEDIA_BASE}/w_en_cool.mp3?${V}`, audioCn: `${MEDIA_BASE}/w_cn_cool.mp3?${V}` },
      ],
    },

    // Step 6: Story (1) — Sentences (1)
    {
      label: 'Learn the Story (1)',
      layout: 'video-top-lines-bottom',
      videos: [{ src: `${MEDIA_BASE}/Ff.mp4?${V}`, startTime: 25, endTime: 41, poster: `${MEDIA_BASE}/image16.png?${V}` }],
      lines: [
        { en: 'Hungry fox finds a fish.', cn: '饥饿的狐狸找到一条鱼', audioEn: `${MEDIA_BASE}/story1_en_1.mp3?${V}`, audioCn: `${MEDIA_BASE}/story1_cn_1.mp3?${V}` },
        { en: 'A big fish.', cn: '一条大鱼', audioEn: `${MEDIA_BASE}/story1_en_2.mp3?${V}`, audioCn: `${MEDIA_BASE}/story1_cn_2.mp3?${V}` },
        { en: 'Flip, flop.', cn: '翻动、扑腾', audioEn: `${MEDIA_BASE}/story1_en_3.mp3?${V}`, audioCn: `${MEDIA_BASE}/story1_cn_3.mp3?${V}` },
        { en: 'Fox is full.', cn: '狐狸吃饱了', audioEn: `${MEDIA_BASE}/story1_en_4.mp3?${V}`, audioCn: `${MEDIA_BASE}/story1_cn_4.mp3?${V}` },
      ],
    },

    // Step 7: Story (2) — Sentences (2)
    {
      label: 'Learn the Story (2)',
      layout: 'video-top-lines-bottom',
      videos: [{ src: `${MEDIA_BASE}/Ff.mp4?${V}`, startTime: 48, endTime: 63, poster: `${MEDIA_BASE}/image17.png?${V}` }],
      lines: [
        { en: 'Hot frog finds a fan.', cn: '感到很热的青蛙找到一把扇子', audioEn: `${MEDIA_BASE}/story2_en_1.mp3?${V}`, audioCn: `${MEDIA_BASE}/story2_cn_1.mp3?${V}` },
        { en: 'A big fan.', cn: '一把大扇子', audioEn: `${MEDIA_BASE}/story2_en_2.mp3?${V}`, audioCn: `${MEDIA_BASE}/story2_cn_2.mp3?${V}` },
        { en: 'Flap.', cn: '扇动', audioEn: `${MEDIA_BASE}/story2_en_3.mp3?${V}`, audioCn: `${MEDIA_BASE}/story2_cn_3.mp3?${V}` },
        { en: 'Frog is cool.', cn: '青蛙凉快了', audioEn: `${MEDIA_BASE}/story2_en_4.mp3?${V}`, audioCn: `${MEDIA_BASE}/story2_cn_4.mp3?${V}` },
      ],
    },

  ],

  // 封面背景图
  coverBg: `${MEDIA_BASE}/image1.jpeg`,

  // 视频封面图
  coverPoster: `${MEDIA_BASE}/cover.png?${V}`,
};

export default letterData;
